export default __webpack_public_path__ + "static/media/Rookwarden's Helm.bc88b762.jpg";